<template>
  <div>
    <v-container class="py-1 pt-0">
      <!-- Titulo y Botón para agregar productos -->
      <v-row>
        <!-- Titulo -->
        <v-col class="py-1 pt-0" cols="12">
          <h1>Detalles de la Orden</h1>
        </v-col>

        <v-col class="py-1" cols="12">
          <v-select
            style="width: 100%"
            label="Productos en pantalla"
            dense
            outlined
            hide-details
            :items="table.limits"
            v-model="table.limit"
            :value="table.limit"
            @change="refreshProducts()"
          >
          </v-select>
        </v-col>

        <v-col
          cols="12"
          align-self="center"
          align="right"
          class="justify-center py-0"
        >
          <div class="deleteButton">
            <v-dialog v-model="deleteDialog" max-width="600" persistent>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="red darken-1"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  width="100%"
                >
                  Limpiar lista <v-icon>delete</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-toolbar color="primary" dark>
                  ¿Estas seguro de limpiar la lista?
                </v-toolbar>

                <v-divider></v-divider>

                <v-container>
                  <div class="msjEliminar">
                    <p>
                      Esta acci&oacute;n eliminara todos los productos de la
                      lista.
                      <br />
                      ¿Desea continuar?
                    </p>
                  </div>
                </v-container>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    color="red darken-1"
                    text
                    @click="deleteDialog = !deleteDialog"
                  >
                    Cancelar
                  </v-btn>

                  <v-spacer></v-spacer>

                  <v-btn color="primary" text @click="clearAll()">
                    Aceptar
                  </v-btn>

                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-col>

        <!-- Botón Agregar productos -->
        <v-col cols="12" class="justify-center py-1">
          <v-dialog
            transition="dialog-top-transition"
            scrollable
            max-width="600"
          >
            <!-- Botón para activar el pop-up. -->
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                v-bind="attrs"
                v-on="on"
                style="width: 100%"
              >
                Agregar productos a la lista
              </v-btn>
            </template>

            <!-- Pop-up para agregar productos a la lista. -->
            <template v-slot:default="dialog">
              <v-card color="secondary">
                <v-toolbar color="primary" dark>
                  Agregar productos a la lista
                </v-toolbar>

                <v-card-text style="height: 340px">
                  <!-- Llamado a componente para agregar productos -->
                  <toolbarQuickOrder
                    :actualizarContadores="actualizarContadores"
                    :toolbar="false"
                    :updateShopingQuantity="updateShopingQuantity"
                    :snackbar="snackbar"
                  >
                  </toolbarQuickOrder>
                </v-card-text>

                <v-card-actions color="secondary">
                  <v-spacer></v-spacer>

                  <v-btn color="red" class="text" @click="dialog.value = false">
                    Cerrar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>

      <v-row>
        <!-- Resumen de pedido-->
        <v-col cols="12" class="py-1">
          <resumeCard
            :products="products"
            :updateShopingQuantity="updateShopingQuantity"
            :snackbar="snackbar"
            :key="totalArt"
          >
          </resumeCard>
        </v-col>
      </v-row>

      <!-- Detalles y resumen de pedido. -->
      <v-row>
        <!-- Detalles del pedido -->
        <v-col cols="12" class="pa-0 pt-2">
          <v-container class="pt-0">
            <v-row>
              <v-col
                cols="12"
                class="py-1"
                v-for="item in table.products"
                :key="item.id"
              >
                <productCardMovil
                  :actualizarContadores="actualizarContadores"
                  :refreshOrderDetail="refreshOrderDetail"
                  :updateShopingQuantity="updateShopingQuantity"
                  :producto="item"
                >
                </productCardMovil>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-pagination
                  v-model="table.page"
                  @input="refreshProducts()"
                  class="my-4"
                  :length="table.pages"
                >
                </v-pagination>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import toolbarQuickOrder from "./quickorderList_child.vue";
import productCardMovil from "./quickorderCardProductMovil_child.vue";
import resumeCard from "./quickorderResumenListado_child.vue";

export default {
  components: { toolbarQuickOrder, productCardMovil, resumeCard },

  data() {
    return {
      table: {
        list: [],
        products: [],
        offset: 0,
        limits: [5, 10, 25, 50],
        limit: 5,
        total: 0,
        pages: 1,
        page: 1,
      },
      deleteDialog: false,
      dialog: false,
      url: "https://risoulimages.s3-us-west-2.amazonaws.com/Imagenes+Items/Imagenes/",
      cartQuantity: 0,
      pieceQuantity: 0,
    };
  },

  props: {
    totalArt: { type: Number },
    products: { type: Array },
    session: { type: Boolean },
    updateShopingQuantity: { type: Function },
    actualizarContadores: { type: Function },
    snackbar: { type: Function },
    deleteAll: { type: Function },
  },

  methods: {
    clearAll: function () {
      this.deleteAll();
      this.deleteDialog = false;
    },

    init: function () {
      var vm = this;
      vm.refreshProducts();
    },

    refreshProducts: function () {
      var vm = this;
      var offset = (vm.table.page - 1) * vm.table.limit;
      var limit = (vm.table.page - 1) * vm.table.limit + vm.table.limit;
      vm.table.products = vm.products.slice(offset, limit);
      vm.table.pages = Math.ceil(vm.table.total / vm.table.limit);
    },

    refreshOrderDetail() {
      this.$forceUpdate();
    },
  },

  computed: {
    cantidadArticulos: function () {
      return this.cartQuantity;
    },
    cantidadPiezas: function () {
      return this.pieceQuantity;
    },
  },

  watch: {},

  created() {
    var vm = this;
    vm.table.total = vm.products.length;
    var orderItems = JSON.parse(localStorage.getItem("shoppingCart"));
    if (orderItems.length > 0) this.actualizarContadores();
    this.init();
  },

  mounted() {},
};
</script>

<style lang="scss" scoped>
@media (min-width: 960px) {
  .quickOrder-container {
    max-width: 90%;
  }
}

@media (min-width: 1264px) {
  .quickOrder-container {
    max-width: 1129px;
  }
}

@media (min-width: 1879px) {
  .quickOrder-container {
    max-width: 1691px;
  }
}

@media (min-width: 1904px) {
  .quickOrder-container {
    max-width: 1556px;
    margin: auto;
  }
}

.msjEliminar {
  margin: auto;
}

.msjEliminar p {
  text-align: center;
}
</style>
